import { DialogTitle, Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdApproval, MdArrowBack, MdArrowRightAlt, MdCalculate, MdCalendarMonth, MdClass, MdContactPhone, MdDone, MdEmail, MdGroup, MdInbox, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdPerson, MdPhoneAndroid, MdRememberMe, MdResetTv, MdSchool, MdSend, MdSettings, MdSettingsAccessibility } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function ResearcherViewStudent() {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    const [studentDetails, setStudentDetails] = useState({
        userEmail: "",
        userFullName: "",
        userRole: "Teacher",
        school: "",
        district: "",
        assignedClass: "",
        dateOfBirth: '',
        penpalGroup: '',
        accountStatus: '',
        preferredLanguage: ""
    });

    useEffect(() => {
        if (localStorage.getItem('userSelected')) {
            setStudentDetails(JSON.parse(localStorage.getItem('userSelected')))
        } else {
            navigate('/researcher/managedata')
        }
    }, [])

    const [isLoading, setIsLoading] = useState(false)
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        navigate('/researcher/managedata')
    };


    const handleDeleteAccount = (email) => {
        setIsLoading(true);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };

        const filterDetails = {
            receiverEmail: email
        };

        const filterDetailsAdminInv = {
            receiverEmail: email,
            userRole: "STUDENT"
        };

        axios.post(`${web_url}/api/invitations/admin/filter`, filterDetailsAdminInv, config).then((resInvA) => {
            // console.log('res inv: ', resInvA);

            if (resInvA.data.length === 0) {

                axios.post(`${web_url}/api/invitations/filter`, filterDetails, config).then((resInv) => {
                    // console.log('res inv: ', resInv);

                    if (resInv.data.length === 0) {
                        axios.delete(`${web_url}/api/auth/students/${email}`, configToken)
                            .then((response) => {

                                setIsLoading(false);
                                navigate('/researcher/managedata')
                            })
                            .catch((err1) => {
                                // console.log(err1.response)
                                if (err1.response) {

                                    if (err1.response.data.error) {
                                        handleClickOpenError(err1.response.data.error);
                                    } else if (err1.response.data.message) {
                                        handleClickOpenError(err1.response.data.message);
                                    } if (err1.response.data.token) {
                                        handleClickOpenError(err1.response.data.token);
                                    } else {
                                        handleClickOpenError("An unknown error occured");
                                    }

                                }
                                setIsLoading(false);
                            })
                    } else {
                        axios.delete(`${web_url}/api/invitations/${resInv.data[0].id}`, configToken).then((resDelInv) => {
                            axios.delete(`${web_url}/api/auth/students/${email}`, configToken)
                                .then((response) => {
                                    setIsLoading(false);
                                    navigate('/researcher/managedata')
                                })
                                .catch((err) => {
                                    if (err.response) {
                                        // console.log(err.response)
                                        if (err.response.data.error) {
                                            handleClickOpenError(err.response.data.error);
                                        } else if (err.response.data.message) {
                                            handleClickOpenError(err.response.data.message);
                                        } if (err.response.data.token) {
                                            handleClickOpenError(err.response.data.token);
                                        } else {
                                            handleClickOpenError("An unknown error occured");
                                        }

                                    }
                                    setIsLoading(false);
                                })
                        }).catch((resDelErr) => {
                            setIsLoading(false);
                            if (resDelErr.response) {
                                // console.log(err.response)
                                if (resDelErr.response.data.error) {
                                    handleClickOpenError(resDelErr.response.data.error);
                                } else if (resDelErr.response.data.message) {
                                    handleClickOpenError(resDelErr.response.data.message);
                                } if (resDelErr.response.data.token) {
                                    handleClickOpenError(resDelErr.response.data.token);
                                } else {
                                    handleClickOpenError("An unknown error occured");
                                }

                            }
                        })
                    }

                }).catch((errInv) => {
                    setIsLoading(false);
                    if (errInv.response) {
                        // console.log(err.response)
                        if (errInv.response.data.error) {
                            handleClickOpenError(errInv.response.data.error);
                        } else if (errInv.response.data.message) {
                            handleClickOpenError(errInv.response.data.message);
                        } if (errInv.response.data.token) {
                            handleClickOpenError(errInv.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                })

            } else {
                axios.delete(`${web_url}/api/invitations/admin/${resInvA.data[0].id}`, configToken).then((resDelInv) => {
                    axios.post(`${web_url}/api/invitations/filter`, filterDetails, config).then((resInv) => {


                        if (resInv.data.length === 0) {
                            axios.delete(`${web_url}/api/auth/students/${email}`, configToken)
                                .then((response) => {
                                    navigate('/researcher/managedata')
                                    setIsLoading(false);
                                })
                                .catch((err1) => {
                                    // console.log(err1.response)
                                    if (err1.response) {

                                        if (err1.response.data.error) {
                                            handleClickOpenError(err1.response.data.error);
                                        } else if (err1.response.data.message) {
                                            handleClickOpenError(err1.response.data.message);
                                        } if (err1.response.data.token) {
                                            handleClickOpenError(err1.response.data.token);
                                        } else {
                                            handleClickOpenError("An unknown error occured");
                                        }

                                    }
                                    setIsLoading(false);
                                })
                        } else {
                            axios.delete(`${web_url}/api/invitations/${resInv.data[0].id}`, configToken).then((resDelInv) => {
                                axios.delete(`${web_url}/api/auth/students/${email}`, configToken)
                                    .then((response) => {
                                        navigate('/researcher/managedata')
                                        setIsLoading(false);
                                    })
                                    .catch((err) => {
                                        if (err.response) {
                                            // console.log(err.response)
                                            if (err.response.data.error) {
                                                handleClickOpenError(err.response.data.error);
                                            } else if (err.response.data.message) {
                                                handleClickOpenError(err.response.data.message);
                                            } if (err.response.data.token) {
                                                handleClickOpenError(err.response.data.token);
                                            } else {
                                                handleClickOpenError("An unknown error occured");
                                            }

                                        }
                                        setIsLoading(false);
                                    })
                            }).catch((resDelErr) => {
                                setIsLoading(false);
                                if (resDelErr.response) {
                                    // console.log(err.response)
                                    if (resDelErr.response.data.error) {
                                        handleClickOpenError(resDelErr.response.data.error);
                                    } else if (resDelErr.response.data.message) {
                                        handleClickOpenError(resDelErr.response.data.message);
                                    } if (resDelErr.response.data.token) {
                                        handleClickOpenError(resDelErr.response.data.token);
                                    } else {
                                        handleClickOpenError("An unknown error occured");
                                    }

                                }
                            })
                        }

                    }).catch((errInv) => {
                        setIsLoading(false);
                        if (errInv.response) {
                            // console.log(err.response)
                            if (errInv.response.data.error) {
                                handleClickOpenError(errInv.response.data.error);
                            } else if (errInv.response.data.message) {
                                handleClickOpenError(errInv.response.data.message);
                            } if (errInv.response.data.token) {
                                handleClickOpenError(errInv.response.data.token);
                            } else {
                                handleClickOpenError("An unknown error occured");
                            }

                        }
                    })
                }).catch((resDelErr) => {
                    setIsLoading(false);
                    if (resDelErr.response) {
                        // console.log(err.response)
                        if (resDelErr.response.data.error) {
                            handleClickOpenError(resDelErr.response.data.error);
                        } else if (resDelErr.response.data.message) {
                            handleClickOpenError(resDelErr.response.data.message);
                        } if (resDelErr.response.data.token) {
                            handleClickOpenError(resDelErr.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                })
            }

        }).catch((errInv) => {
            setIsLoading(false);
            if (errInv.response) {
                // console.log(err.response)
                if (errInv.response.data.error) {
                    handleClickOpenError(errInv.response.data.error);
                } else if (errInv.response.data.message) {
                    handleClickOpenError(errInv.response.data.message);
                } if (errInv.response.data.token) {
                    handleClickOpenError(errInv.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }
            }
        })


    }

    const handleStatusUpdate = (statusText, email) => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.put(`${web_url}/api/auth/students/${email}/account-status?status=${statusText}`, {}, configToken)
            .then((response) => {
                setIsLoading(false);
                navigate('/researcher/managedata')
            })
            .catch((err) => {
                if (err.response) {
                    // console.log(err.response)
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } if (err.response.data.token) {
                        handleClickOpenError(err.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setIsLoading(false);
            })
    }

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden w-screen xl:pt-[20px] pb-[100px] xl:pb-[30px]`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/researcher/managedata')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/researcher/managedata')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/researcher/managedata')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t139')}</p>
                    </div>
                </div>

                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdPerson size="24px" color="#8189B0" />
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0">{studentDetails.userFullName.length > 35
                                    ? `${studentDetails.userFullName.slice(0, 35)}...`
                                    : studentDetails.userFullName}</p>
                            </div>

                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdEmail size="24px" color="#8189B0" />
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0">{studentDetails.userEmail.length > 35
                                    ? `${studentDetails.userEmail.slice(0, 35)}...`
                                    : studentDetails.userEmail}</p>
                            </div>

                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdCalendarMonth size="24px" color="#8189B0" />
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0">{studentDetails.dateOfBirth}</p>
                            </div>

                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                {/* <MdGroup size="24px" color="#8189B0" /> */}
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"><span className="font-bold">{t('t31')}: </span>
                                    {studentDetails.preferredLanguage
                                        ? studentDetails.preferredLanguage
                                        : " No Preferred language"}
                                </p>
                            </div>

                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                {/* <MdGroup size="24px" color="#8189B0" /> */}
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"><span className="font-bold">{t('t418')}: </span>
                                    {studentDetails.penpalGroup
                                        ? (studentDetails.penpalGroup === "CONTROL" ? t('t183') : t('t182'))
                                        : " No Penpal Group"}
                                </p>
                            </div>

                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                {/* <MdContactPhone size="24px" color="#8189B0" /> */}
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"><span className="font-bold">{t('t55')}: </span>
                                    {studentDetails.district.length > 35
                                        ? `${studentDetails.district.slice(0, 35)}...`
                                        : studentDetails.district}</p>
                            </div>

                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                {/* <MdContactPhone size="24px" color="#8189B0" /> */}
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"><span className="font-bold">{t('t33')}: </span> {studentDetails.school.length > 35
                                    ? `${studentDetails.school.slice(0, 35)}...`
                                    : studentDetails.school}</p>
                            </div>

                            <div className="ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                {/* <MdContactPhone size="24px" color="#8189B0" /> */}
                                <p className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] md:text-[17px] lg:text-[18px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"><span className="font-bold">{t('t35')} & {t('t37')}: </span> {studentDetails.assignedClass.length > 35
                                    ? `${studentDetails.assignedClass.slice(0, 35)}...`
                                    : studentDetails.assignedClass}</p>
                            </div>

                            <div className="ml-[20px] mt-[30px] md:ml-[150px] lg:ml-[250px] xl:ml-[400px] 2xl:ml-[600px]">
                                <p className="text-[18px] font-bold text-black">{t('t140')}</p>
                            </div>
                            <div className="flex justify-center gap-[20px] ml-[20px] mr-[20px] md:mx-[150px] lg:mx-[250px] xl:mx-[400px] 2xl:mx-[600px]">
                                <button disabled={isLoading} className={`text-[18px] mt-[20px] rounded-lg pt-[15px] pb-[15px] w-[400px] bg-opacity-50 ${studentDetails.accountStatus == "ACTIVE" ? 'bg-[#0EF26D]' : 'bg-[#BDBDBD]'}`} onClick={() => { setStudentDetails((prev) => ({ ...prev, accountStatus: 'ACTIVE' })) }}>{t("t131_1")}</button>
                                <button disabled={isLoading} className={`text-[18px] mt-[20px] rounded-lg pt-[15px] pb-[15px] w-[400px] ${studentDetails.accountStatus == "INACTIVE" ? 'bg-[#0EF26D]' : 'bg-[#BDBDBD]'} bg-opacity-50`} onClick={() => { setStudentDetails((prev) => ({ ...prev, accountStatus: 'INACTIVE' })) }}>{t("t132_1")}</button>
                            </div>

                            <div className="flex justify-center gap-[20px] ml-[20px] mr-[20px] md:mx-[150px] lg:mx-[250px] xl:mx-[400px] 2xl:mx-[600px] mt-[20px] md:mt-[40px] xl:mt-[20px] 2xl:mt-[40px]">
                                <button onClick={() => {
                                    if (isXlOrLarger) {
                                        // localStorage.removeItem('mailreceived')
                                        // localStorage.removeItem('mailsent')
                                        navigate('/desktop/researcher/student/viewprofile')
                                    } else {
                                        navigate('/mobile/researcher/student/mailprofile/view')
                                    }
                                }} disabled={isLoading} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[700px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">{t('t208')}</button>
                            </div>

                            <div className="flex justify-center gap-[20px] ml-[20px] mr-[20px] md:mx-[150px] lg:mx-[250px] xl:mx-[400px] 2xl:mx-[600px] mt-[20px] md:mt-[20px] xl:mt-[20px] 2xl:mt-[70px]">
                                <button onClick={handleClickOpen} disabled={isLoading} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[400px] hover:bg-opacity-80 bg-[#F2290E] bg-opacity-20">{t('t141')}</button>
                                <button onClick={() => { handleStatusUpdate(studentDetails.accountStatus, studentDetails.userEmail) }} disabled={isLoading} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[400px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t146')}</button>
                            </div>
                        </>
                }
            </div>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[30px]'>{t('t143')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t145')}
                                </Button>
                                <Button
                                    onClick={() => { handleDeleteAccount(studentDetails.userEmail) }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t144')}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ResearcherViewStudent;
